@if (componentState | async; as compState) {
  <div class="page-container">
    @if (compState.loading) {
      <em-block-ui></em-block-ui>
    }
    <div class="title-bar">
      <div class="intro-title" translate>ENTERPRISE_PAGE_TITLE</div>
      @if (compState.authState === 'done') {
        <button mat-flat-button color="primary" (click)="logout()">
          <mat-icon aria-hidden="false" aria-label="logout icon">
            logout
          </mat-icon>
          <span>{{ 'BUTTON_LOGOUT' | translate }}</span>
        </button>
      }
    </div>
    @if (compState.noAccountsSelectable) {
      <h2 class="no-accounts">
        {{ 'ENTERPRISE_NO_ADWORDS_ACCOUNTS' | translate }}
      </h2>
    }
    @if (compState.authState === 'unauthorized') {
      <div class="login-with-google-container">
        <button
          mat-flat-button
          [disabled]="!compState.sdkReady"
          color="primary"
          (click)="loginWithGoogle()"
        >
          {{ 'ENTERPRISE_LOGIN_WITH_GOOGLE' | translate }}
        </button>
      </div>
    }
    @if (compState.adwordsAccounts.total) {
      <div class="search-container">
        <input
          mat-input
          [(ngModel)]="searchValue"
          [placeholder]="'ENTERPRISE_SEARCH_PLACEHOLDER' | translate"
        />
      </div>
      @if (compState.authState !== 'unauthorized') {
        <div class="adwords-account-list-header">
          <div class="label" (click)="changeOrderBy('id')">
            <span translate>ADWORDS_ACCOUNT_ID</span>
            @if (isActive('id')) {
              @if (orderDirection === 'asc') {
                <mat-icon class="sort-icon">arrow_drop_up</mat-icon>
              }
              @if (orderDirection === 'desc') {
                <mat-icon class="sort-icon">arrow_drop_down</mat-icon>
              }
            }
          </div>
          <div class="label" (click)="changeOrderBy('name')">
            <span translate>ADWORDS_ACCOUNT_NAME</span>
            @if (isActive('name')) {
              @if (orderDirection === 'asc') {
                <mat-icon class="sort-icon">arrow_drop_up</mat-icon>
              }
              @if (orderDirection === 'desc') {
                <mat-icon class="sort-icon">arrow_drop_down</mat-icon>
              }
            }
          </div>
          <div class="label" (click)="changeOrderBy('managedByName')">
            <span translate>ADWORDS_ACCOUNT_MANAGED_BY</span>
            @if (isActive('managedByName')) {
              @if (orderDirection === 'asc') {
                <mat-icon class="sort-icon">arrow_drop_up</mat-icon>
              }
              @if (orderDirection === 'desc') {
                <mat-icon class="sort-icon">arrow_drop_down</mat-icon>
              }
            }
          </div>
          <div
            class="label with-tooltip"
            matTooltip="{{ 'SHARED_LABEL_LAST_30_DAYS' | translate }}"
          >
            <mat-icon class="info-icon">info</mat-icon>
            <span translate>ADWORDS_ACCOUNT_COSTS</span>
          </div>
          <div
            class="label with-tooltip"
            matTooltip="{{ 'SHARED_LABEL_LAST_30_DAYS' | translate }}"
          >
            <mat-icon class="info-icon">info</mat-icon>
            <span translate>ADWORDS_ACCOUNT_CONVERSIONS</span>
          </div>
          <div
            class="label with-tooltip"
            matTooltip="{{ 'SHARED_LABEL_LAST_30_DAYS' | translate }}"
          >
            <mat-icon class="info-icon">info</mat-icon>
            <span translate>ADWORDS_ACCOUNT_CLICKS</span>
          </div>
          <div
            class="label with-tooltip"
            matTooltip="{{ 'SHARED_LABEL_LAST_30_DAYS' | translate }}"
          >
            <mat-icon class="info-icon">info</mat-icon>
            <span translate>ADWORDS_ACCOUNT_REVENUE</span>
          </div>
          <div class="label" (click)="changeOrderBy('currencyCode')">
            <span translate>ADWORDS_ACCOUNT_CURRENCY</span>
            @if (isActive('currencyCode')) {
              @if (orderDirection === 'asc') {
                <mat-icon class="sort-icon">arrow_drop_up</mat-icon>
              }
              @if (orderDirection === 'desc') {
                <mat-icon class="sort-icon">arrow_drop_down</mat-icon>
              }
            }
          </div>
          <div class="label end" translate>ADWORDS_ACCOUNT_ACTIONS</div>
        </div>
      }
      <div class="adwords-account-list-container">
        <cdk-virtual-scroll-viewport itemSize="48" class="example-viewport">
          <div
            *cdkVirtualFor="
              let account of compState.adwordsAccounts.search(searchValue);
              trackBy: adwordsTrackByFn
            "
            class="container"
          >
            <div class="details-item head">
              {{ account.id | formatAdwordsId }}
            </div>
            <div class="details-item name" [title]="account.name">
              <div class="value">
                {{ account.name }}
                @if (!account.name) {
                  <span class="noname" translate>ADWORDS_ACCOUNT_NO_NAME</span>
                }
              </div>
            </div>
            <div class="details-item managed-by">
              <div class="value" [title]="account.managedByName">
                {{ account.managedByName }}
              </div>
              <div class="value value-dimmed" [title]="account.managedById">
                {{ account.managedById }}
              </div>
            </div>
            @if (
              getPerformanceData(
                account.id,
                compState.performanceData,
                account.currencyCode,
                account.loginCustomerId
              );
              as performance
            ) {
              <div class="details-item costs">
                <div class="value">{{ performance.costs | withCurrency }}</div>
              </div>
              <div class="details-item conversions">
                <div class="value">
                  {{ performance.conversions | allowZero }}
                </div>
              </div>
              <div class="details-item clicks">
                <div class="value">{{ performance.clicks | allowZero }}</div>
              </div>
              <div class="details-item revenue">
                <div class="value">
                  {{ performance.revenue | withCurrency }}
                </div>
              </div>
            } @else {
              <div class="details-item costs"></div>
              <div class="details-item conversions">
                <div class="value">
                  <em-spinner class="em-spinner-mini"></em-spinner>
                </div>
              </div>
              <div class="details-item clicks"></div>
              <div class="details-item revenue"></div>
            }
            <div class="details-item currency">
              <div class="value">
                {{ account.currencyCode }} ({{
                  account.currencyCode | currencySymbol
                }})
              </div>
            </div>
            <div class="action">
              @if (account.jwt === false) {
                <div class="note-wrapper">
                  <mat-icon>info</mat-icon>
                  <div class="note">
                    {{ 'ENTERPRISE_UNAUTHORIZED_NOTE' | translate }}
                  </div>
                </div>
              }
              @if (account.jwt === null) {
                <button
                  mat-flat-button
                  color="primary"
                  (click)="
                    create(
                      account.id,
                      account.currencyCode,
                      account.loginCustomerId
                    )
                  "
                >
                  {{ 'ENTERPRISE_CREATE_BUTTON' | translate }}
                </button>
              }
              @if (account.jwt !== null && account.jwt !== false) {
                <a
                  mat-flat-button
                  emSingleUse
                  color="primary"
                  [href]="'/?jwt=' + account.jwt"
                  target="_blank"
                >
                  <mat-icon aria-hidden="false" aria-label="open_in_new icon">
                    open_in_new
                  </mat-icon>
                  {{ 'ENTERPRISE_LOGIN_BUTTON' | translate }}
                </a>
              }
            </div>
          </div>
        </cdk-virtual-scroll-viewport>
      </div>
    }
  </div>
}
